import { render, staticRenderFns } from "./GroupListSelection.vue?vue&type=template&id=852c0a1a&"
import script from "./GroupListSelection.vue?vue&type=script&lang=ts&"
export * from "./GroupListSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports